/**
 * Floating WhatsApp "ask a question" button.
 *
 * Visible on every page (bottom-right). On click it opens wa.me with a
 * pre-filled French message so the candidate can hit Send without thinking.
 * The phone is normalised to the international format wa.me expects (digits
 * only, no '+').
 */

import { trackEvent } from '../lib/track';

// MTC's WhatsApp business line. International format, digits only.
const PHONE = '212707707606';

const PREFILLED_MESSAGE =
  'Bonjour MTC, je souhaite des informations sur vos formations.';

function buildHref() {
  return `https://wa.me/${PHONE}?text=${encodeURIComponent(PREFILLED_MESSAGE)}`;
}

export function WhatsAppFab() {
  return (
    <a
      className="wa-fab"
      href={buildHref()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Discuter avec MTC sur WhatsApp"
      title="Discuter sur WhatsApp"
      onClick={() => trackEvent('whatsapp_click')}
    >
      {/* Official WhatsApp glyph — single-color so it inherits via fill */}
      <svg
        className="wa-fab-icon"
        viewBox="0 0 32 32"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M16.001 3.2C8.94 3.2 3.2 8.94 3.2 16c0 2.255.59 4.456 1.71 6.4L3.2 28.8l6.55-1.715A12.798 12.798 0 0 0 16.001 28.8C23.063 28.8 28.8 23.063 28.8 16S23.063 3.2 16.001 3.2Zm0 23.36c-1.97 0-3.9-.523-5.591-1.512l-.4-.236-3.886 1.018 1.037-3.79-.26-.413A10.498 10.498 0 0 1 5.44 16c0-5.823 4.738-10.56 10.56-10.56 5.823 0 10.56 4.737 10.56 10.56 0 5.823-4.737 10.56-10.56 10.56Zm5.789-7.91c-.317-.158-1.876-.926-2.167-1.032-.29-.106-.503-.158-.715.16-.211.317-.82 1.031-1.005 1.243-.184.21-.37.237-.687.08-.317-.16-1.34-.494-2.553-1.575-.943-.842-1.58-1.882-1.766-2.2-.184-.317-.02-.488.139-.646.143-.142.317-.37.475-.555.158-.184.211-.317.317-.528.105-.211.052-.396-.026-.555-.08-.158-.715-1.72-.98-2.356-.258-.62-.521-.535-.715-.545l-.61-.011a1.17 1.17 0 0 0-.846.396c-.29.317-1.112 1.086-1.112 2.648 0 1.563 1.138 3.073 1.297 3.285.158.211 2.24 3.421 5.428 4.795.759.327 1.351.522 1.813.668.762.243 1.456.209 2.005.127.612-.092 1.876-.766 2.141-1.507.264-.74.264-1.374.184-1.507-.08-.132-.29-.211-.607-.37Z"
        />
      </svg>
    </a>
  );
}
